import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { Emitter, type Event } from '@patsnap/tahiti-core/common/event';

export interface AbstractModel<ModelData = any> {
    modelData: ModelData;
    update: (getUpdateValue: (value: ModelData) => ModelData) => void;
    onStatesChange: Event<ModelData>;
}

@injectable()
export abstract class AbstractModelImpl<ModelData = any> implements AbstractModel<ModelData> {
    protected abstract _modelData: ModelData;
    private _onStatesChangeEmitter = new Emitter<ModelData>();
    public readonly onStatesChange = this._onStatesChangeEmitter.event;

    get modelData(): ModelData {
        return _.cloneDeep(this._modelData);
    }

    private _emitModelDataChange() {
        this._onStatesChangeEmitter.fire(this.modelData);
    }

    private _update(value: ModelData) {
        this._modelData = value;
    }

    public update(getUpdateValue: (value: ModelData) => ModelData) {
        this._update(getUpdateValue(this.modelData));
        this._emitModelDataChange();
    }
}
